import { ref } from "vue";

const saveSubscriptionButtonRef = ref();

const sharedRefs = {
  saveSubscriptionButtonRef
};

export default sharedRefs;